Intl = require 'intl'
Intl.__addLocaleData require('intl-locale-data')



// WEBPACK FOOTER //
// ./app/scripts/init/intl-polyfill.coffee